import React, {Component} from 'react';
import AccountRemittanceContainer from '../../../containers/account_remittance_container';
import {Header, Tab} from 'semantic-ui-react';
import RemittanceEstimates from "./estimates";
import RemittanceList from "./remittances";

class Remittance extends Component {

    constructor(props) {
        super(props);
        this.state = {
            view: 'estimate'
        }
    }

    render() {
        const panes = [
            {menuItem: 'Estimates', render: () => <Tab.Pane><RemittanceEstimates/></Tab.Pane>},
            {menuItem: 'Remittances', render: () => <Tab.Pane><RemittanceList/></Tab.Pane>},
        ];

        return (<div style={{width: '95%', margin: 'auto'}}>
            <Header className="pad-top" content="Remittances" size="large" textAlign="left"/>
            <Tab panes={panes}/>
        </div>)
    }
}

export default AccountRemittanceContainer(Remittance);


// WEBPACK FOOTER //
// ./src/views/accounts/remittance/index.js